module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACkSURBVHgB7ZPdDYUgDIWpen8e7wg+MAAJi9wX5pFNHM0RHAHbpCppAH8SffIkJ4T08JGUotSjSxRC6Mhn6zL8D6v6RL2P6mYP8IceUlABo0ybg8h9K6G7YSxIXCKhWzAoAhlq0GMEGwt9g/ggZEIxtAQ7JoaajQyoR5eKGlyhG/Qb/SVrrT/W2pf3vlKZUStC+eVqBjfOufosbNH8LWmlC24fjwnjGduCfXHgMwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./images/Checkbox.png
// module id = 840
// module chunks = 117